import { ThunkDispatch } from "core-integration/src/store";
import { banLeagueEntry } from "core-integration/src/store/leagues/thunks";
import {
  IBanEntryData,
  IPrivateLeagueAdmin,
} from "core-integration/src/store/leagues/types";
import React, { useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Button from "../../Button";
import { FieldWrap } from "../../FieldRenderers";
import SubHeading from "../../SubHeading";
import EntrySelector from "./EntrySelector";

interface IOwnProps {
  league: IPrivateLeagueAdmin;
}

type Props = IOwnProps & WithTranslation;

const AddBan: React.FC<Props> = ({ league, t }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useNavigate();
  const [entry, setEntry] = useState<number>(0);

  const handleEntryChange = (entryId: number) => {
    setEntry(entryId);
  };

  const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    await dispatch(banLeagueEntry(league.id, apiDataFromState()));
    navigate("/leagues");
  };

  const apiDataFromState = (): IBanEntryData => ({
    entry,
  });

  const disabled = !entry;
  return (
    <>
      <SubHeading>{t("addBan.title", "Add league suspensions")}</SubHeading>
      <p>
        {t(
          "addBan.description",
          "Search for the player you wish to suspend from this league. Once the player has been suspended they will be unable to rejoin the league again.",
        )}
      </p>
      <form onSubmit={handleSubmit}>
        <FieldWrap>
          <EntrySelector
            handleChange={handleEntryChange}
            leagueId={league.id}
            excluded={[league.admin_entry]}
          />
        </FieldWrap>
        <FieldWrap>
          <Button type="submit" disabled={disabled}>
            {t("addBan.suspendPlayer", "Suspend player")}
          </Button>
        </FieldWrap>
      </form>
    </>
  );
};

export { AddBan as AddBanTest };

export default withTranslation()(AddBan);
